import { render, staticRenderFns } from "./DownLoadVersion.vue?vue&type=template&id=1dc0395a"
import script from "./DownLoadVersion.vue?vue&type=script&lang=js"
export * from "./DownLoadVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports